/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as RolesRouteImport } from './routes/roles'
import { Route as McpRouteImport } from './routes/mcp'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GroupsRouteImport } from './routes/groups'
import { Route as GrantsRouteImport } from './routes/grants'
import { Route as ConversationsRouteImport } from './routes/conversations'
import { Route as ConfigRouteImport } from './routes/config'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users.index'
import { Route as UsersIdRouteImport } from './routes/users.$id'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const RolesRoute = RolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const McpRoute = McpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const GroupsRoute = GroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => rootRouteImport,
} as any)
const GrantsRoute = GrantsRouteImport.update({
  id: '/grants',
  path: '/grants',
  getParentRoute: () => rootRouteImport,
} as any)
const ConversationsRoute = ConversationsRouteImport.update({
  id: '/conversations',
  path: '/conversations',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigRoute = ConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UsersRoute,
} as any)
const UsersIdRoute = UsersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => UsersRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/billing': typeof BillingRoute
  '/config': typeof ConfigRoute
  '/conversations': typeof ConversationsRoute
  '/grants': typeof GrantsRoute
  '/groups': typeof GroupsRoute
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/roles': typeof RolesRoute
  '/users': typeof UsersRouteWithChildren
  '/users/$id': typeof UsersIdRoute
  '/users/': typeof UsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/billing': typeof BillingRoute
  '/config': typeof ConfigRoute
  '/conversations': typeof ConversationsRoute
  '/grants': typeof GrantsRoute
  '/groups': typeof GroupsRoute
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/roles': typeof RolesRoute
  '/users/$id': typeof UsersIdRoute
  '/users': typeof UsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/billing': typeof BillingRoute
  '/config': typeof ConfigRoute
  '/conversations': typeof ConversationsRoute
  '/grants': typeof GrantsRoute
  '/groups': typeof GroupsRoute
  '/login': typeof LoginRoute
  '/mcp': typeof McpRoute
  '/roles': typeof RolesRoute
  '/users': typeof UsersRouteWithChildren
  '/users/$id': typeof UsersIdRoute
  '/users/': typeof UsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/billing'
    | '/config'
    | '/conversations'
    | '/grants'
    | '/groups'
    | '/login'
    | '/mcp'
    | '/roles'
    | '/users'
    | '/users/$id'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/billing'
    | '/config'
    | '/conversations'
    | '/grants'
    | '/groups'
    | '/login'
    | '/mcp'
    | '/roles'
    | '/users/$id'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/billing'
    | '/config'
    | '/conversations'
    | '/grants'
    | '/groups'
    | '/login'
    | '/mcp'
    | '/roles'
    | '/users'
    | '/users/$id'
    | '/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditRoute: typeof AuditRoute
  BillingRoute: typeof BillingRoute
  ConfigRoute: typeof ConfigRoute
  ConversationsRoute: typeof ConversationsRoute
  GrantsRoute: typeof GrantsRoute
  GroupsRoute: typeof GroupsRoute
  LoginRoute: typeof LoginRoute
  McpRoute: typeof McpRoute
  RolesRoute: typeof RolesRoute
  UsersRoute: typeof UsersRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roles': {
      id: '/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof RolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mcp': {
      id: '/mcp'
      path: '/mcp'
      fullPath: '/mcp'
      preLoaderRoute: typeof McpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/groups': {
      id: '/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof GroupsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grants': {
      id: '/grants'
      path: '/grants'
      fullPath: '/grants'
      preLoaderRoute: typeof GrantsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversations': {
      id: '/conversations'
      path: '/conversations'
      fullPath: '/conversations'
      preLoaderRoute: typeof ConversationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config': {
      id: '/config'
      path: '/config'
      fullPath: '/config'
      preLoaderRoute: typeof ConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof UsersRoute
    }
    '/users/$id': {
      id: '/users/$id'
      path: '/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof UsersIdRouteImport
      parentRoute: typeof UsersRoute
    }
  }
}

interface UsersRouteChildren {
  UsersIdRoute: typeof UsersIdRoute
  UsersIndexRoute: typeof UsersIndexRoute
}

const UsersRouteChildren: UsersRouteChildren = {
  UsersIdRoute: UsersIdRoute,
  UsersIndexRoute: UsersIndexRoute,
}

const UsersRouteWithChildren = UsersRoute._addFileChildren(UsersRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  BillingRoute: BillingRoute,
  ConfigRoute: ConfigRoute,
  ConversationsRoute: ConversationsRoute,
  GrantsRoute: GrantsRoute,
  GroupsRoute: GroupsRoute,
  LoginRoute: LoginRoute,
  McpRoute: McpRoute,
  RolesRoute: RolesRoute,
  UsersRoute: UsersRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
